import { registerPlugin } from '@capacitor/core';
const Chromaprint = registerPlugin('Chromaprint', {
    web: () => import('./web').then((m) => new m.ChromaprintWeb()),
});
export * from './definitions';
export { Chromaprint };
//# sourceMappingURL=index.js.map